import { CustomerApi } from 'api'

export const recordConsent = (id, message) => (
  CustomerApi.post(`/end_users/${id}/consent`, {
    consentId: 'has_consent',
    message
  })
)

export const getEndUser = (id) => (
  CustomerApi.get(`/end_users/${id}`)
)
